
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: false,
    },
  },

  methods: {
    checkClick(): void {
      if (this.type === "print") {
        window.print();
      } else if (this.type === "message") {
        const link = window.location.href;
        navigator
          .share({
            title: this.title,
            text: "Check out " + this.title,
            url: link,
          })
          .catch((error) => console.log("Error sharing", error));
      } else {
        const windowFeatures = "width=620,height=620";
        window.open(this.generateLink, "NewWindow" + this.type, windowFeatures);
      }
    },
  },

  computed: {
    generateLink(): string | undefined {
      const link = window.location.href;
      if (this.type === "facebook") {
        return (
          "http://www.facebook.com/sharer/sharer.php?u=" +
          encodeURIComponent(link)
        );
      } else if (this.type === "twitter") {
        return (
          "https://twitter.com/intent/tweet?text=" +
          encodeURIComponent(this.title ?? "") +
          "&url=" +
          encodeURIComponent(link)
        );
      } else if (this.type === "linkedin") {
        return (
          "https://www.linkedin.com/sharing/share-offsite/?url=" +
          encodeURIComponent(link)
        );
      } else if (this.type === "pinterest") {
        return (
          "https://www.pinterest.com/pin/create/link/?url=" +
          encodeURIComponent(link) +
          "&description=" +
          encodeURIComponent((this.description ?? "").replace(/<[^>]+>/g, "")) +
          "&media=" +
          encodeURIComponent((this.image ?? "").replace(/<[^>]+>/g, ""))
        );
      }
      return undefined;
    },

    generateClass(): string {
      if (this.type === "facebook") {
        return "my-3 me-1 share-button facebook-share";
      } else if (this.type === "twitter") {
        return "my-3 mx-1 share-button twitter-share";
      } else if (this.type === "linkedin") {
        return "my-3 ms-1 me-2 share-button linkedin-share";
      } else if (this.type === "pinterest") {
        return "my-3 me-1 share-button pinterest-share";
      } else if (this.type === "print") {
        return "my-3 mx-1 share-button print-share";
      } else {
        return "my-3 mx-1 share-button message-share";
      }
    },

    generateIcon(): string {
      if (this.type === "facebook") {
        return "fa-brands fa-facebook-f";
      } else if (this.type === "twitter") {
        return "fa-brands fa-x-twitter";
      } else if (this.type === "linkedin") {
        return "fa-brands fa-linkedin-in";
      } else if (this.type === "pinterest") {
        return "fa-brands fa-pinterest";
      } else if (this.type === "print") {
        return "fa-solid fa-print";
      } else {
        return "fa-solid fa-message";
      }
    },
  },
});
